import React, { useEffect, useState } from "react";
import { useForm, UseFormRegister, FieldErrors } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../../service/validation/vehicle";
import Input from "../../../../components/FormInputs";
import AdminContainer from "../../../Admin";
import { VehicleFormData } from "../../../../service/interfaces/Forms";
import DatePicker from "../../../../components/Datepicker";
import TitleSelect from "../../../../components/Dropdown";
import PhoneInput from "../../../../components/phoneinput";
import { useNavigate, useParams } from "react-router-dom";
import FormTitle from "../../../../components/FormTitle";
interface OwnerDetailsProps {
  register: UseFormRegister<VehicleFormData>;
  errors: FieldErrors<VehicleFormData>;
  watch: any;
  setValue: any;
  control: any;
  useSameContact: boolean;
  setUseSameContact: React.Dispatch<React.SetStateAction<boolean>>;
}

const OwnerDetails: React.FC<OwnerDetailsProps> = ({
  register,
  errors,
  watch,
  setValue,
  control,
  useSameContact,
  setUseSameContact,
}) => {
  const { id } = useParams();

  return (
    <div className="bg-white p-6 rounded-[20px] font-poppins">
      <FormTitle title="Owner Details" />
      <div className="flex items-center mb-4">
      </div>
      <div className="flex items-center">
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col md:flex-row gap-2">
            <div className="w-[100px]">
              <TitleSelect
                value={watch("ownerDetails.title") as string || "Mr."}
                onChange={(newValue: string) =>
                  setValue("ownerDetails.title", newValue, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
                register={register}
                name="ownerDetails.title"
                errors={errors}
                setValue={setValue}
                label=""
                placeholder="Select"
              />
            </div>
            <Input
              label="First Name"
              name="ownerDetails.firstName"
              errors={errors}
              register={register}
              uppercase={true}
              placeholder="Enter first name"
              type="text"
            />
            <Input
              label="Last Name"
              name="ownerDetails.lastName"
              errors={errors}
              register={register}
              uppercase={true}
              placeholder="Enter last name"
              type="text"
            />
            <Input
              label="Owner Name"
              name="ownerDetails.ownerName"
              errors={errors}
              register={register}
              uppercase={true}
              placeholder="Enter owner name"
              type="text"
            />
            <Input
              label="Company Name"
              name="ownerDetails.companyName"
              errors={errors}
              register={register}
              uppercase={true}
              placeholder="Enter company name"
              type="text"
            />
            <Input
              label="Email Id"
              name="ownerDetails.emailId"
              errors={errors}
              register={register}
              placeholder="Enter email id"
              type="text"
            />
            <PhoneInput
              label="Phone Number"
              name="ownerDetails.phoneNumber"
              defaultCountry="IN"
              type="tel"
              errors={errors}
              maxLength={10}
              placeholder="Enter phone number"
              control={control}
              onChange={({ countryCode, phoneNumber }) => {
                setValue("ownerDetails.phoneNumber", phoneNumber);
                setValue("ownerDetails.countryCode", countryCode);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerDetails;
